"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function NewsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <Card key={i} data-index={i} className="h-[420px] animate-pulse border-none shadow-md">
            <div className="h-48 w-full bg-muted" />
            <CardHeader className="px-5 pt-5 pb-2">
              <div className="h-6 w-3/4 rounded bg-muted" />
              <div className="mt-2 h-6 w-1/2 rounded bg-muted" />
            </CardHeader>
            <CardContent className="px-5 py-0">
              <div className="mt-2 space-y-2">
                <div className="h-4 w-full rounded bg-muted" />
                <div className="h-4 w-full rounded bg-muted" />
                <div className="h-4 w-2/3 rounded bg-muted" />
              </div>
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="mt-10 text-center font-sans text-muted-foreground">
        Failed to load expert advice.
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="mt-10 text-center font-sans text-muted-foreground">
        No articles available at the moment.
      </div>;
  }
  return <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group flex h-full flex-col overflow-hidden border-none bg-card shadow-md transition-all duration-400 ease-[cubic-bezier(0.4,0,0.2,1)] hover:-translate-y-1 hover:shadow-xl">
          <div className="relative h-48 w-full shrink-0 overflow-hidden">
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654438/img/editorial_advice_thumb.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            {}
            <div className="absolute right-0 top-0 h-12 w-12 rounded-bl-xl bg-chart-2/90 shadow-sm backdrop-blur-sm" />
          </div>
          <CardHeader className="px-5 pt-5 pb-2">
            <CardTitle className="font-default text-xl font-semibold leading-tight text-foreground line-clamp-2">
              {post.title}
            </CardTitle>
          </CardHeader>
          <CardContent className="grow px-5 py-0">
            <div className="font-default text-sm leading-relaxed text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{
          __html: post.excerpt || ""
        }} />
          </CardContent>
          <CardFooter className="mt-auto px-5 pb-5 pt-6">
            <Button asChild className="w-full rounded-full bg-primary font-default text-primary-foreground shadow-sm transition-transform hover:scale-105 hover:bg-primary/90">
              <Link to={post.link || "#"}>Read Article</Link>
            </Button>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function TravelersJournal() {
  const wp_query_params = {
    post_type: "post",
    per_page: 4
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="236665" id="latest-advice" className="bg-secondary py-16 md:py-24">
      <div className="mx-auto max-w-screen-xl px-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 border-b border-border pb-6 sm:flex-row sm:items-end">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Latest Advice
          </h2>
          <Link to="/HomePage" className="group flex items-center gap-2 font-default text-sm font-medium text-muted-foreground transition-colors hover:text-primary">
            <span className="underline-offset-4 group-hover:underline">
              Explore All Guides
            </span>
            <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 4
      }}>
          <NewsGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}